module.exports = __webpack_public_path__ + "img/fr.b6f9aef6.png";